import styled from 'styled-components'
import {
  P, H4, Div,
} from 'konsys-ui'
import { theme, media } from '../../styles/_variables'

export const BgContainer = styled.div`
  background-color: ${theme.color.offWhite};
  padding: 72px 0;
  ${media.tablet`
    padding: 40px 0;
  `}
`

export const WidthContainer = styled.div`
  width: 100%;
  max-width: ${theme.maxWidth};
  margin-left: 50%;
  transform: translateX(-50%);
  padding: 0 16px;
  ${media.tablet`
    width: 100%;
    max-width: 100%;
  `}
  h3 {
    font-weight: 600;
    ${media.tablet`
      font-size: ${theme.fonts.size.subTitle};
    `}
  }
  h4 {
    ${media.tablet`
      font-size: ${theme.fonts.size.extraNormal};
    `}
  }
`

export const ChoiceContainer = styled.div`
  margin: 24px 0 0;
`

export const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 12px 0 18px;
`

export const Title = styled(H4)`
  color: ${props => (props.color ? props.color : props.superGreen ? theme.color.tertiaryColor : theme.color.primaryColor)};
`

export const ChoiceWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  background-image: ${props => props.bgImg && `url(${props.bgImg})`};
  background-size: cover;
  background-position: top center;
  padding: 36px 0;
  ${media.laptop`
    background-position: bottom center;
  `}
`

export const EachChoiceContainer = styled.div`
  display: flex;
  flex-direction: row;
  ${media.tablet`
    flex-direction: column;
    align-items: center;
    padding: 24px 0;
  `}
`

export const EachChoiceBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px 48px 48px;
  border: 1px solid ${theme.color.offWhite};
  width: 400px;
  margin: 0 10px;
  border-radius: 2px;
  transition: all 0.5s ease;
  cursor: pointer;
  > * {
    color: ${theme.color.offWhite};
  }
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
    > button {
      background-color: ${theme.color.primaryColor};
      > p {
        color: ${theme.color.offWhite} !important;
      }
    }
  }
  &:active {
    > button {
      border: 1px solid ${theme.color.offWhite};
      background-color: ${theme.color.offWhite};
      > p {
        color: ${theme.color.lightBlack} !important;
      }
    }
  }
  ${media.tablet`
    width: 80%;
    margin: 8px auto 0;
  `}
`

export const EachChoiceBoxContentWrapper = styled.div`
  margin: 12px 24px 0;
  > p {
    color: ${theme.color.offWhite};
    text-align: center;
  }
  ${media.mobileM`
    width: 100%;
  `}
`

export const ImgDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 240px;
  height: 240px;
`

export const Img = styled.img`
  max-height: 222px;
  max-width: 200px;
`

export const ContentContianer = styled.div`
  margin: 48px 0 0;
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`

export const ContentTitleWrapper = styled.div`
  margin-bottom: 16px;
`

export const SubContentWrapper = styled.div`
  margin: 24px 0 0 48px;
  ${media.mobileM`
    margin: 24px 0 0 24px;
  `}
`

export const SubText = styled(P)`
  font-weight: ${props => (props.bold ? '900' : '200')};
  color: ${props => props.light && theme.color.lightGrey};
  padding: ${props => props.addSpace && '0 0 0 6px'};
`

export const SampleDiv = styled(Div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 8px 0 0;
  ${media.tablet`
    flex-wrap: wrap;
  `}
  ${media.mobileM`
    flex-direction: column;
  `}
`

export const SampleImg = styled.div`
  max-width: 160px;
  min-height: 160px;
  width: 160px;
  height: 160px;
  border-radius: 80px;
  margin: 8px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  -webkit-mask-image: -webkit-radial-gradient(white, black);
  &:before {
    content: '';
    transition: all 0.5s ease;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: ${props => props.src && `url(${props.src})`};
    background-size: cover;
  }
  &:hover {
    &:before {
      transform: scale(1.2);
    }
  }
`

export default BgContainer



// WEBPACK FOOTER //
// ./src/pages/printing-information/styled.js